module.exports = React;


/*****************
 ** WEBPACK FOOTER
 ** external "React"
 ** module id = 40
 ** module chunks = 46 47
 **/